/** Must match backend `ocrLimits.TEXTRACT_OCR_WALL_MS` (single-document OCR wait). */
export const TEXTRACT_OCR_MAX_WAIT_MS = 2 * 60 * 1000; // 2 minutes
